import { ButtonComponent, TextFieldComponent } from "@/components";
import { IMAGES, MOBILE_REGEX, WEB_COLORS } from "@/lib/constants";
import {
  FormControlLabel,
  Grid,
  Stack,
  Box,
  Typography,
  Checkbox,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";
import styles from "../personal-loan-landing.module.css";

const GetStarted = ({ formik, handleFieldChange }) => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack position={"relative"}>
      <Box className={styles["trapezoid-left-modal"]}></Box>
      <Box className={styles["trapezoid-right-modal"]}></Box>

      <Grid
        container
        gap={1}
        display={"flex"}
        alignItems={"flex-start"}
        justifyContent={"center"}
      >
        <Typography
          fontWeight={700}
          color={WEB_COLORS.darkTeal}
          fontSize={{ md: "40px", xs: "24px" }}
        >
          Get
        </Typography>
        <Typography
          fontWeight={700}
          color={"#F35A21"}
          fontSize={{ md: "40px", xs: "24px" }}
        >
          Started
        </Typography>
      </Grid>
      <TextFieldComponent
        shrink
        type="number"
        name="phone"
        maxLength={10}
        value={formik?.values?.phone}
        placeholder={"Enter your phone number"}
        errorMessage={formik?.errors?.phone}
        error={Boolean(formik?.touched?.phone && formik?.errors?.phone)}
        success={Boolean(formik?.touched?.phone && !formik?.errors?.phone)}
        onBlur={formik.handleBlur}
        onChange={(e) => {
          handleFieldChange(e, MOBILE_REGEX);
        }}
        inputPropsStyle={{ color: "#4D6767" }}
        size=""
        backgroundColor={"white"}
      />
      <Stack width={"100%"}>
        <FormControlLabel
          control={
            <Checkbox
              name="terms"
              checked={formik.values.terms}
              onChange={formik.handleChange}
              sx={{
                color: WEB_COLORS.darkTeal, // color of unchecked box border and checkmark color
                "&.Mui-checked": {
                  color: WEB_COLORS.darkTeal, // color when checked
                },
              }}
            />
          }
          label={
            <Typography color={WEB_COLORS.darkTeal} fontSize={14}>
              {t("termsandconditions")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("terms")}
              </a>{" "}
              {t("and")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("privacy")}
              </a>{" "}
              {t("consent")}
            </Typography>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              name="whatsapp"
              checked={formik.values.whatsapp}
              onChange={formik.handleChange}
              sx={{
                color: WEB_COLORS.darkTeal, // color of unchecked box border and checkmark color
                "&.Mui-checked": {
                  color: WEB_COLORS.darkTeal, // color when checked
                },
              }}
            />
          }
          label={
            <Typography
              color={WEB_COLORS.darkTeal}
              fontSize={14}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              {t("whatsapp")}{" "}
              <Image
                src={IMAGES.whatsApp}
                alt="whatsApp"
                height={25}
                width={25}
              />
            </Typography>
          }
        />
        <Stack>
          <ButtonComponent
            toolTipTitle={t("loginttoltip")}
            type="submit"
            onClick={formik.handleSubmit}
            disabled={!(formik.isValid && formik.dirty)}
            size={`${isMobile ? "small" : ""}`}
            buttonStyle={{
              height: "60px",
              backgroundColor: WEB_COLORS.darkTeal,
              color: "#fff",
              cursor: "pointer",
              pt: 2,
              "&:hover": {
                backgroundColor: WEB_COLORS.darkTeal,
                color: "#fff",
                cursor: "pointer",
              },
              "&:disabled": {
                backgroundColor: "#407168",
                color: "#fff",
              },
            }}
          >
            Apply Now
          </ButtonComponent>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default GetStarted;
